var Curriculog = Curriculog || {};

Curriculog.DecisionFilter = (function ($, _, Backbone, DecisionFilter) {

	DecisionFilter = Backbone.View.extend({

		el: function () {
			return $('.decision');
		},

		events: {
			'click': 'evaluate',
		},

		initialize: function(options) {
			this.params = options.params;
			this.listenTo(Backbone, 'empty:on', this._disable);
			this.listenTo(Backbone, 'empty:off', this._enable);
		},

		get: function() {
			// populates the advanced filter select checkboxes to match the default
			// base query or the search in session
			var decisionFilter = this.params.queryParams.get('decision');
			$('input[id^="report-9-decision"]:checked').attr('checked', false);
			_.each(decisionFilter, function(element, index) {
				$('#report-9-decision-' + element).attr('checked', true);
			});
			this.disable();
		},

		set: function() {
			var decisionList = $('input[id^="report-9-decision"]:checked').map(function (k, v) {
					var decision = $(v).attr('name').split('-').reverse()[0];
					return 'request-' + decision;
				}).get();
			this.params.queryParams.set('decision', decisionList);
		},

		disable: function(){
			var tab = this.params.domParams.get('tab');
			if (tab == 'completed'){
				$('input[id^="report-9-decision"]').attr('disabled', true);
			}else{
				$('input[id^="report-9-decision"]').attr('disabled', false);
			}
		},

		_disable: function() {
			// disables checkboxes
			$('input[id^="report-9-decision"]').attr('checked', false);
			$('input[id^="report-9-decision"]').attr('disabled', true);
		},

		_enable: function() {
			// enables checkboxes
			$('input[id^="report-9-decision"]').attr('disabled', false);
		},

		evaluate: function() {
			// checks if the field is on, and fires an event to disable 
			// mutually exclusive advanced filter options
			if (this.params.domParams.get('tab') === 'completed') {
				// in completed filter, this isn't applicable
				return;
			}

			if ($('input[id^="report-9-decision"]:checked').length > 0) {
				Backbone.trigger('decision:on');
			} else {
				Backbone.trigger('decision:off');
			}
		}

	});

	return DecisionFilter;

})($, _, Backbone, Curriculog.DecisionFilter || {});